/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PersonFeedbackGroupDetail {
  age?: number;
  badge?: string;
  birthday?: string;
  birthdayDate?: Date;
  birthdayMonth?: string;
  boxId?: string;
  feedbackGroupId?: number;
  options?: string;
  personId?: number;
  personName?: string;
  personType?: string;
  shippingCity?: string;
  shippingState?: string;
  subscriberId?: number;
  subscriptionName?: string;
}
